import React, {Component} from 'react'
import CssBaseline from "@material-ui/core/CssBaseline";
class Settings extends Component{
    render(){
        return(
            <div>
                <CssBaseline />Settings</div>
        )
    }
}

export default () => {
    return (
        <Settings/>
    )
}